module.exports = __webpack_public_path__ + "static/media/icn_couple.d63714ba.svg";